// src/pages/UserPages/UserSettingsPage.js

import React, { useMemo } from "react";
import { Box, Typography, Button, TextField } from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { useThemeMode } from "../../components/ThemeModeContext";

import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";
import FeedbackButton from "../../components/FeedbackButton";
import FeedbackSnackbar from "../../components/FeedbackSnackbar";

export default function UserSettingsPage() {
  const { mode } = useThemeMode();

  // Se houver necessidade de Snackbar, pode adicionar aqui
  const [openSnackbar, setOpenSnackbar] = React.useState(false);
  const [snackbarMsg, setSnackbarMsg] = React.useState("");
  const [snackbarSeverity, setSnackbarSeverity] = React.useState("success");

  // Cria o tema dinamicamente
  const theme = useMemo(
    () =>
      createTheme({
        palette: {
          mode,
          background: {
            default: mode === "light" ? "#FAF5E4" : "#121212",
            paper: mode === "light" ? "#FFFFFF" : "#1E1E1E",
          },
          text: {
            primary: mode === "light" ? "#1A202C" : "#FFFFFF",
          },
        },
      }),
    [mode]
  );

  // Exemplo de função para salvar configurações
  const handleSaveSettings = () => {
    // Lógica de salvar configurações (chamar API, etc.)
    setSnackbarMsg("Settings saved successfully!");
    setSnackbarSeverity("success");
    setOpenSnackbar(true);
  };

  // Fecha o Snackbar
  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  return (
    <ThemeProvider theme={theme}>
      <Box
        display="flex"
        flexDirection="column"
        minHeight="100vh"
        bgcolor="background.default"
        color="text.primary"
      >
        {/* Navbar */}
        <Navbar />

        {/* Conteúdo Principal */}
        <Box p={3} flexGrow={1}>
          <Typography
            variant="h4"
            textAlign="center"
            fontWeight="bold"
            gutterBottom
          >
            User Settings
          </Typography>

          <Box
            sx={{
              maxWidth: 600,
              margin: "0 auto",
              mt: 4,
            }}
          >
            <Typography variant="body1" gutterBottom>
              Altere suas informações de usuário, preferências, etc.
            </Typography>

            {/* Exemplo de campos de configuração */}
            <Box display="flex" flexDirection="column" gap={2} mt={2}>
              <TextField
                label="Nome"
                variant="outlined"
                size="small"
                fullWidth
              />
              <TextField
                label="Email"
                variant="outlined"
                size="small"
                fullWidth
              />
              <TextField
                label="Senha"
                variant="outlined"
                size="small"
                type="password"
                fullWidth
              />
              {/* Botão de Salvar */}
              <Button
                variant="contained"
                color="primary"
                sx={{ alignSelf: "flex-end", mt: 2 }}
                onClick={handleSaveSettings}
              >
                Save Settings
              </Button>
            </Box>
          </Box>
        </Box>

        {/* Snackbar para feedback */}
        <FeedbackSnackbar
          open={openSnackbar}
          handleClose={handleCloseSnackbar}
          message={snackbarMsg}
          severity={snackbarSeverity}
        />

        {/* Botão de Feedback (DarkMode + Feedback) */}
        <FeedbackButton />

        {/* Rodapé */}
        <Footer />
      </Box>
    </ThemeProvider>
  );
}
